import { Injectable } from '@angular/core'
import { SmODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { IEntityGroup } from './entityGroup'
import { IClaimConfigurationType } from './claimConfigurationType'
import { IClaimTransactionType } from './claimTransactionType'
import { ODataService } from 'common-services'

export interface IClaimConfiguration extends IModelBase {
  EntityGroupId: number
  EntityGroup: IEntityGroup

  ConfigurationTypeId: number
  ConfigurationType: IClaimConfigurationType

  TransactionTypeId: number
  TransactionType: IClaimTransactionType
}

@Injectable()
export class ClaimConfigurationODataService extends ODataService<IClaimConfiguration> {
  constructor(
    protected http: HttpClient,
    protected config: SmODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'ClaimConfigurations'
  }
}
